module.exports = __webpack_public_path__ + "media/logo/logo_sal-dd46f067.png";